export default __webpack_public_path__ + "static/media/referral-code-background.79d1fe52.png";